import { Outlet, Navigate } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';
import { UsernameRegistration } from './components/organisms/UsernameRegistration';
import { Toaster } from './components/atoms/ui/toaster';
import { TooltipProvider } from './components/atoms/ui/tooltip';
import { RouteErrorElement } from './components/organisms/RouteErrorElement';
import { LandingPage } from './pages/LandingPage';
import { LoginPage } from './pages/LoginPage';
import { BoardPage } from './pages/BoardPage';
import { UserProfilePage } from './pages/UserProfilePage';
import { BrowseBoardPage } from './pages/BrowseBoardPage';
import { UsersPage } from './pages/UsersPage';
import { ImportPage } from './pages/ImportPage';
import { ImportPngPage } from './pages/ImportPngPage';
import { SketchBoardPage } from './pages/SketchBoardPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { GuidelinesPage } from './pages/GuidelinesPage';

// Layout component that wraps all routes with UsernameRegistration, TooltipProvider, and Toaster
const RootLayout = () => {
  return (
    <TooltipProvider>
      <UsernameRegistration />
      <Outlet />
      <Toaster />
    </TooltipProvider>
  );
};

// Routes configuration for data router
export const routes: RouteObject[] = [
  {
    element: <RootLayout />,
    errorElement: <RouteErrorElement />,
    children: [
      {
        path: '/',
        element: <LandingPage />,
      },
      {
        path: '/login',
        element: <LoginPage />,
      },
      {
        path: '/browse',
        element: <BrowseBoardPage />,
      },
      {
        path: '/users',
        element: <UsersPage />,
      },
      {
        path: '/board/:boardName',
        element: <BoardPage />,
      },
      {
        path: '/user/:username',
        element: <UserProfilePage />,
      },
      {
        path: '/import',
        element: <ImportPage />,
      },
      {
        path: '/import-png',
        element: <ImportPngPage />,
      },
      {
        path: '/sketch',
        element: <SketchBoardPage />,
      },
      {
        path: '/terms',
        element: <TermsPage />,
      },
      {
        path: '/privacy',
        element: <PrivacyPage />,
      },
      {
        path: '/guidelines',
        element: <GuidelinesPage />,
      },
      {
        path: '*',
        element: <Navigate to="/" replace />,
      },
    ],
  },
];
